import { FormattedMessage as FM } from "react-intl";

import ToolbarBoard from "./ToolbarBoard";

function BoardHeader(props) {
  const {
    ctxView,
    submodel,
    Toolbar,
    onChangeView,
    viewType,
    onChangeDate,
    handleFilter,
  } = props;
  const title = ctxView.model && <FM id={ctxView.model} />;

  return (
    <div
      id="board-header"
      className="md:flex flex-wrap md:flex-nowrap px-4 md:py-1 items-center"
    >
      <div className="flex md:my-4 col-span-12 w-1/3 text-zinc-500">
        {submodel ? (
          <h2 className="truncate text-xl">{title}</h2>
        ) : (
          <h1 className="truncate md:text-4xl text-2xl font-light">{title}</h1>
        )}
      </div>
      {Toolbar && <div className="flex w-1/3 text-neutral-500">{Toolbar}</div>}
      <ToolbarBoard
        viewType={viewType}
        actions={ctxView.table_action}
        ctxView={ctxView}
        onChangeView={onChangeView}
        onChangeDate={onChangeDate}
        handleFilter={handleFilter}
      />
    </div>
  );
}

export default BoardHeader;
